module.exports = "<app-image #imageComponent></app-image>\r\n<app-text #textComponent></app-text>\r\n"


//////////////////
// WEBPACK FOOTER
// C:/ETT/Progetti/JumpvNext/Angular/AgentiWebUI/AgentiWebConqordOil.Web.UI/src/app/components/utils/dynamic/components/image-with-html/image-with-html.component.html
// module id = ../../../../../src/app/components/utils/dynamic/components/image-with-html/image-with-html.component.html
// module chunks = main